<div class = "confirmation-dialog-main">
    <div class = "confirmation-dialog-title">{{ data.title }}</div>
    <div #message class = "confirmation-dialog-message"></div>
    <div class = "confirmation-dialog-actions">
        <button mat-flat-button class = "confirmation-dialog-confirm"  [mat-dialog-close] = "true"> {{data.yesText}} </button>
        <button mat-flat-button class = "confirmation-dialog-decline" [mat-dialog-close] = "false"> {{data.noText}} </button>
    </div>
</div>
